import { fetchApi } from '@/services/api-client';

export type StudentSstSupervision = {
  id: string;
  studentId: string;
  active: boolean;
  startedAt: string;
  startedById: string | null;
  startedByName: string | null;
  endedAt: string | null;
  endedById: string | null;
  endedByName: string | null;
  reason: string | null;
  endNote: string | null;
};

const path = (studentId: string) => `/students/${studentId}/sst-supervisions`;

export const sstSupervisionsApi = {
  list: (studentId: string) => fetchApi<StudentSstSupervision[]>(path(studentId)),
  start: (studentId: string, reason: string) =>
    fetchApi<StudentSstSupervision>(path(studentId), {
      method: 'POST',
      body: JSON.stringify({ reason }),
    }),
  end: (studentId: string, note?: string) =>
    fetchApi<StudentSstSupervision>(`${path(studentId)}/current/end`, {
      method: 'POST',
      body: JSON.stringify({ note }),
    }),
};
